(function () {
  function parseQuizData(section) {
    const dataNode = section.querySelector('[data-find-dashcam-data]');
    if (!dataNode) return null;

    try {
      return JSON.parse(dataNode.textContent);
    } catch (error) {
      console.error('Find Your Dashcam: invalid quiz data.', error);
      return null;
    }
  }

  function getSelectionForQuestion(question, container) {
    if (question.type === 'dropdown') {
      const select = container.querySelector('[data-question-select]');
      return select && select.value ? [select.value] : [];
    }

    const checkedInputs = container.querySelectorAll('input:checked');
    return Array.from(checkedInputs).map(function (input) {
      return input.value;
    });
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function renderQuestion(section, questions, state) {
    const question = questions[state.currentIndex];
    const host = section.querySelector('[data-question-host]');
    const prevButton = section.querySelector('[data-quiz-prev]');
    const progressText = section.querySelector('[data-quiz-progress-text]');
    const progressFill = section.querySelector('[data-quiz-progress-fill]');
    const status = section.querySelector('[data-quiz-status]');

    if (!question || !host) return;

    const selectedValues = state.answers[question.id] || [];
    const progressPercentage = ((state.currentIndex + 1) / questions.length) * 100;

    progressText.textContent = 'Question ' + (state.currentIndex + 1) + ' of ' + questions.length;
    progressFill.style.width = progressPercentage + '%';
    prevButton.disabled = state.currentIndex === 0;

    status.textContent =
      question.type === 'multiple'
        ? 'You can select more than one option.'
        : 'Select one option to continue.';

    if (question.type === 'dropdown') {
      host.innerHTML =
        '<div class="find-dashcam__select-box">' +
        '  <label class="visually-hidden" for="FindDashcamSelect-' +
        question.id +
        '">' +
        question.title +
        '</label>' +
        '  <div class="find-dashcam__select-wrap">' +
        '    <select id="FindDashcamSelect-' +
        question.id +
        '" class="find-dashcam__select-native" data-question-select>' +
        '      <option value="">Choose an option</option>' +
        question.options
          .map(function (option) {
            const isSelected = selectedValues.includes(option.id) ? ' selected' : '';
            return (
              '<option value="' +
              option.id +
              '"' +
              isSelected +
              '>' +
              escapeHtml(option.label) +
              '</option>'
            );
          })
          .join('') +
        '    </select>' +
        '    <svg class="find-dashcam__select-icon" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="m4 6 4 4 4-4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '  </div>' +
        '</div>';
    } else {
      host.innerHTML =
        '<div class="find-dashcam__options">' +
        question.options
          .map(function (option) {
            const inputType = question.type === 'multiple' ? 'checkbox' : 'radio';
            const checked = selectedValues.includes(option.id) ? ' checked' : '';
            return (
              '<label class="find-dashcam__option">' +
              '  <input type="' +
              inputType +
              '" name="find-dashcam-' +
              question.id +
              '" value="' +
              option.id +
              '"' +
              checked +
              '>' +
              '  <span class="find-dashcam__option-label">' +
              '    <span class="find-dashcam__option-indicator" aria-hidden="true">' +
              (question.type === 'multiple'
                ? '<svg viewBox="0 0 16 16" fill="none"><path d="M3.5 8.5 6.5 11.5 12.5 4.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>'
                : '<svg viewBox="0 0 16 16" fill="currentColor"><circle cx="8" cy="8" r="3.2"/></svg>') +
              '    </span>' +
              '    <span class="find-dashcam__option-text">' +
              escapeHtml(option.label) +
              '</span>' +
              '  </span>' +
              '</label>'
            );
          })
          .join('') +
        '</div>';
    }

    host.insertAdjacentHTML(
      'afterbegin',
      '<h3 class="find-dashcam__question-title">' + escapeHtml(question.title) + '</h3>'
    );

    updateActions(section, questions, state);
  }

  function updateActions(section, questions, state) {
    const question = questions[state.currentIndex];
    const host = section.querySelector('[data-question-host]');
    const nextButton = section.querySelector('[data-quiz-next]');
    const submitButton = section.querySelector('[data-quiz-submit]');
    const selectedValues = getSelectionForQuestion(question, host);
    const hasSelection = selectedValues.length > 0;
    const isLastQuestion = state.currentIndex === questions.length - 1;

    if (isLastQuestion) {
      nextButton.hidden = true;
      submitButton.hidden = !hasSelection;
      submitButton.disabled = !hasSelection;
    } else {
      submitButton.hidden = true;
      nextButton.hidden = !hasSelection;
      nextButton.disabled = !hasSelection;
    }
  }

  function collectSelectedOptionLabels(questions, answers) {
    const labels = [];

    questions.forEach(function (question) {
      const selectedOptionIds = answers[question.id] || [];

      question.options.forEach(function (option) {
        if (!selectedOptionIds.includes(option.id)) return;
        if (option.label && labels.indexOf(option.label) === -1) {
          labels.push(option.label);
        }
      });
    });

    return labels;
  }

  function collectProducts(questions, answers) {
    const byId = new Map();

    questions.forEach(function (question) {
      const selectedOptionIds = answers[question.id] || [];

      question.options.forEach(function (option) {
        if (!selectedOptionIds.includes(option.id)) return;

        const optionLabel = option.label || '';
        const optionProducts = Array.isArray(option.products) ? option.products : [];

        optionProducts.forEach(function (product) {
          if (!product || product.id == null) return;

          const existing = byId.get(String(product.id));
          if (existing) {
            if (optionLabel && existing.optionLabels.indexOf(optionLabel) === -1) {
              existing.optionLabels.push(optionLabel);
            }
            return;
          }

          byId.set(String(product.id), {
            id: product.id,
            html: product.html || '',
            optionLabels: optionLabel ? [optionLabel] : []
          });
        });
      });
    });

    return Array.from(byId.values()).filter(function (product) {
      return Boolean(product.html && product.html.trim());
    });
  }

  function applyOptionBadges(cardGrid, products) {
    if (!cardGrid) return;

    const cards = cardGrid.querySelectorAll('.find-dashcam__product-item');
    cards.forEach(function (card, index) {
      const product = products[index];
      if (!product) return;

      const badgeHost = card.querySelector('[data-quiz-option-badges]');
      if (!badgeHost) return;

      const labels = product.optionLabels && product.optionLabels.length ? product.optionLabels : [];

      if (!labels.length) {
        badgeHost.innerHTML = '';
        return;
      }

      badgeHost.innerHTML = labels
        .map(function (label) {
          return '<span class="dashcam-products__card-badge">' + escapeHtml(label) + '</span>';
        })
        .join('');
    });
  }

  function renderSelectedOptions(section, labels) {
    const host = section.querySelector('[data-selected-options]');
    if (!host) return;

    if (!labels.length) {
      host.innerHTML = '';
      host.hidden = true;
      return;
    }

    host.innerHTML = labels
      .map(function (label) {
        return '<span class="find-dashcam__selected-chip">' + escapeHtml(label) + '</span>';
      })
      .join('');
    host.hidden = false;
  }

  function renderResults(section, questions, state) {
    const products = collectProducts(questions, state.answers);
    const selectedLabels = collectSelectedOptionLabels(questions, state.answers);
    const cardGrid = section.querySelector('[data-results-grid]');
    const results = section.querySelector('[data-results]');
    const empty = section.querySelector('[data-results-empty]');
    const quizCard = section.querySelector('[data-quiz-card]');

    if (!cardGrid || !results || !empty) return;

    renderSelectedOptions(section, selectedLabels);

    if (products.length) {
      cardGrid.innerHTML = products
        .map(function (product) {
          return '<div class="find-dashcam__product-item">' + (product.html || '') + '</div>';
        })
        .join('');

      applyOptionBadges(cardGrid, products);
      results.hidden = false;
      empty.hidden = true;
      if (quizCard) quizCard.hidden = true;
      results.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      cardGrid.innerHTML = '';
      results.hidden = true;
      empty.hidden = false;
      if (quizCard) quizCard.hidden = true;
      empty.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  function initQuiz(section) {
    if (section.dataset.quizReady === 'true') return;

    const quizData = parseQuizData(section);
    if (!quizData || !Array.isArray(quizData.questions) || !quizData.questions.length) return;

    section.dataset.quizReady = 'true';

    const questions = quizData.questions;
    const state = {
      currentIndex: 0,
      answers: {}
    };

    renderQuestion(section, questions, state);

    section.addEventListener('change', function (event) {
      const question = questions[state.currentIndex];
      const host = section.querySelector('[data-question-host]');
      if (!host || !host.contains(event.target)) return;

      state.answers[question.id] = getSelectionForQuestion(question, host);
      updateActions(section, questions, state);
    });

    section.querySelector('[data-quiz-prev]').addEventListener('click', function () {
      const question = questions[state.currentIndex];
      const host = section.querySelector('[data-question-host]');
      state.answers[question.id] = getSelectionForQuestion(question, host);

      if (state.currentIndex > 0) {
        state.currentIndex -= 1;
        renderQuestion(section, questions, state);
      }
    });

    section.querySelector('[data-quiz-next]').addEventListener('click', function () {
      const question = questions[state.currentIndex];
      const host = section.querySelector('[data-question-host]');
      const selections = getSelectionForQuestion(question, host);

      if (!selections.length) return;

      state.answers[question.id] = selections;

      if (state.currentIndex < questions.length - 1) {
        state.currentIndex += 1;
        renderQuestion(section, questions, state);
      }
    });

    section.querySelector('[data-quiz-submit]').addEventListener('click', function () {
      const question = questions[state.currentIndex];
      const host = section.querySelector('[data-question-host]');
      const selections = getSelectionForQuestion(question, host);

      if (!selections.length) return;

      state.answers[question.id] = selections;
      renderResults(section, questions, state);
    });

    section.querySelectorAll('[data-quiz-restart]').forEach(function (button) {
      button.addEventListener('click', function () {
        state.currentIndex = 0;
        state.answers = {};
        const cardGrid = section.querySelector('[data-results-grid]');
        if (cardGrid) cardGrid.innerHTML = '';
        renderSelectedOptions(section, []);
        section.querySelector('[data-results]').hidden = true;
        section.querySelector('[data-results-empty]').hidden = true;
        section.querySelector('[data-quiz-card]').hidden = false;
        renderQuestion(section, questions, state);
      });
    });
  }

  function initFindYourDashcam() {
    document.querySelectorAll('[data-find-your-dashcam]').forEach(initQuiz);
  }

  document.addEventListener('DOMContentLoaded', initFindYourDashcam);
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-find-your-dashcam]').forEach(function (section) {
      section.dataset.quizReady = '';
      initQuiz(section);
    });
  });
})();
